import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import axios from 'axios';
import AsyncSelect from 'react-select/async';
import ReactHtmlParser from 'react-html-parser';
import MultiSelectCreatableTextInput from '../MultiSelectCreatableTextInput';
import { isMobile } from '../../../screenUtils';
import { getValuesContaining, getValuesWithout, filterOutDuplicateObjects } from '../../../arrayUtils';
import DropdownIndicator from '../DropdownIndicator';
import dropdownStyleUtils from '../../../dropdownStyleUtils';
import './MultiSelectInput.scss';
import { analyticsTrack } from '../../../analyticsUtils';
var components = {
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: function IndicatorSeparator() {
    return null;
  }
};
var reorderSeniorityOption = function reorderSeniorityOption(options, mobile) {
  // re-order the Seniory options to be display appropriately
  var order = ['Associate', 'Vice President', 'Manager', 'C-Level', 'Director'];
  var orderMobile = ['Associate', 'Manager', 'Director', 'Vice President', 'C-Level'];
  var reOrderedOption = [];
  if (mobile) {
    orderMobile.forEach(function (label) {
      var found = options.find(function (el) {
        return el.label === label;
      });
      if (found) reOrderedOption.push(found);
    });
  } else {
    order.forEach(function (label) {
      var found = options.find(function (el) {
        return el.label === label;
      });
      if (found) reOrderedOption.push(found);
    });
  }
  return reOrderedOption;
};
var MultiSelectInput = /*#__PURE__*/function (_Component) {
  function MultiSelectInput(props) {
    var _this;
    _classCallCheck(this, MultiSelectInput);
    _this = _callSuper(this, MultiSelectInput, [props]);
    _this.customValues = getValuesContaining(props.values, 'custom:');
    _this.nonCustomValues = getValuesWithout(props.values, 'custom:');
    _this.state = {
      otherSelected: _this.customValues.length > 0,
      menuIsOpen: props.menuIsOpen,
      showLimitReached: false,
      usedOptions: props.options
    };
    _this.withinLimit = _this.withinLimit.bind(_this);
    _this.toggleOtherSelected = _this.toggleOtherSelected.bind(_this);
    _this.getOptions = _this.getOptions.bind(_this);
    _this.handleFilterChange = _this.handleFilterChange.bind(_this);
    _this.handleCustomSelectChange = _this.handleCustomSelectChange.bind(_this);
    _this.handleNonCustomSelectChange = _this.handleNonCustomSelectChange.bind(_this);
    _this.handleAllSelect = _this.handleAllSelect.bind(_this);
    _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
    return _this;
  }
  _inherits(MultiSelectInput, _Component);
  return _createClass(MultiSelectInput, [{
    key: "getOptions",
    value: function getOptions(input) {
      var asyncUrl = this.props.asyncUrl;
      return axios.get(asyncUrl, {
        params: {
          term: input
        }
      }).then(function (response) {
        var compare = response.data.filter(function (i) {
          return i.label.toLowerCase().includes(input.toLowerCase());
        });
        return compare.map(function (i) {
          return {
            label: i.label,
            value: i.value
          };
        });
      });
    }
  }, {
    key: "withinLimit",
    value: function withinLimit(values) {
      var limit = this.props.limit;
      return limit === null || values.length <= limit || this.nonCustomValues.length > values.length;
    }
  }, {
    key: "toggleOtherSelected",
    value: function toggleOtherSelected() {
      var otherSelected = this.state.otherSelected;
      var _this$props = this.props,
        questionKey = _this$props.questionKey,
        onboardingQuestionnaire = _this$props.onboardingQuestionnaire,
        userId = _this$props.userId,
        text = _this$props.text;

      // If Other is currently selected and we are toggling it to
      // be unselected, then we should clear the custom values.
      if (otherSelected === true) {
        analyticsTrack("Toggling Other - ".concat(text), {
          location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
          questionKey: questionKey,
          action: 'Enabled',
          userId: userId
        });
        this.customValues = [];
        if (!this.isLimitReached()) {
          this.setState({
            showLimitReached: false
          });
        }
      } else {
        analyticsTrack("Toggling Other - ".concat(text), {
          location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
          questionKey: questionKey,
          action: 'Disabled',
          userId: userId
        });
        if (this.isLimitReached()) {
          this.setState({
            showLimitReached: true
          });
          return;
        }
      }
      this.handleAllSelect();
      this.setState({
        otherSelected: !otherSelected
      });
    }
  }, {
    key: "handleToggleMenu",
    value: function handleToggleMenu() {
      var closeOnSelect = this.props.closeOnSelect;
      if (this.props.menuIsOpen && !closeOnSelect) return;
      this.setState({
        menuIsOpen: !this.state.menuIsOpen
      });
    }
  }, {
    key: "handleAllSelect",
    value: function handleAllSelect() {
      var handleSelectChange = this.props.handleSelectChange;
      handleSelectChange([].concat(_toConsumableArray(this.nonCustomValues), _toConsumableArray(this.customValues)));
    }
  }, {
    key: "handleNonCustomSelectChange",
    value: function handleNonCustomSelectChange(values) {
      var _this$props2 = this.props,
        questionKey = _this$props2.questionKey,
        text = _this$props2.text,
        onboardingQuestionnaire = _this$props2.onboardingQuestionnaire,
        userId = _this$props2.userId;
      if (Array.isArray(values)) {
        if (this.withinLimit(values)) {
          this.nonCustomValues = values;
        }
      } else {
        var index = this.nonCustomValues.findIndex(function (x) {
          return x.value === values.value;
        });
        var action;
        if (index !== -1) {
          this.nonCustomValues.splice(index, 1);
          action = 'Removed';
          if (!this.isLimitReached()) {
            this.setState({
              showLimitReached: false
            });
          }
        } else {
          action = 'Added';
          if (this.isLimitReached()) {
            analyticsTrack("Attempting to add more - ".concat(text), {
              location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
              value: values.label,
              questionKey: questionKey,
              action: action,
              userId: userId
            });
            this.setState({
              showLimitReached: true
            });
            return;
          }
          this.nonCustomValues.push(values);
        }
        analyticsTrack("Indicating ".concat(text), {
          location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
          value: values.label,
          questionKey: questionKey,
          action: action,
          userId: userId
        });
      }
      this.handleAllSelect();
    }
  }, {
    key: "handleCustomSelectChange",
    value: function handleCustomSelectChange(values, action) {
      var _this$props3 = this.props,
        questionKey = _this$props3.questionKey,
        text = _this$props3.text,
        onboardingQuestionnaire = _this$props3.onboardingQuestionnaire,
        userId = _this$props3.userId;
      var newValues;
      if (action === 'clear') {
        newValues = [];
      } else if (action === 'delete-value-key') {
        newValues = _toConsumableArray(values).slice(0, -1);
      } else if (action === 'remove-value') {
        newValues = _toConsumableArray(values);
      } else if (!this.isLimitReached()) {
        var deduped = filterOutDuplicateObjects(this.customValues, values.value);
        newValues = [].concat(_toConsumableArray(deduped), [values]);
      }
      analyticsTrack("Action on Other - ".concat(text), {
        location: onboardingQuestionnaire ? 'Onboarding Flow' : 'Not Onboarding Flow',
        value: values.label,
        questionKey: questionKey,
        action: action,
        userId: userId
      });
      var onlyCustom = this.props.onlyCustom;
      if (!onlyCustom || onlyCustom && this.withinLimit(newValues)) {
        this.customValues = newValues;
        this.handleAllSelect();
      }
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(value) {
      var usedOptions = this.state.usedOptions;
      var options = this.props.options;
      usedOptions = options.filter(function (opt) {
        return opt.label.toLowerCase().includes(value.toLowerCase());
      });
      this.setState({
        usedOptions: usedOptions
      });
    }
  }, {
    key: "isLimitReached",
    value: function isLimitReached() {
      var limit = this.props.limit;
      return limit ? this.nonCustomValues.length + this.customValues.length >= limit : false;
    }
  }, {
    key: "renderLimitWarning",
    value: function renderLimitWarning() {
      var limit = this.props.limit;
      if (limit && this.isLimitReached()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "question-warning body-text-2 mb-2"
        }, "You have selected ".concat(limit, " options. You cannot select another one."));
      }
      return null;
    }
  }, {
    key: "renderCreatableTextInput",
    value: function renderCreatableTextInput() {
      var _this$props4 = this.props,
        hasOther = _this$props4.hasOther,
        onlyCustom = _this$props4.onlyCustom,
        disabled = _this$props4.disabled;
      var otherSelected = this.state.otherSelected;
      if (hasOther && otherSelected || onlyCustom) {
        return /*#__PURE__*/React.createElement(MultiSelectCreatableTextInput, {
          values: this.customValues,
          handleCustomSelectChange: this.handleCustomSelectChange,
          isDisabled: disabled,
          enterPrompt: onlyCustom
        });
      }
      return null;
    }
  }, {
    key: "renderSelect",
    value: function renderSelect() {
      var _this2 = this;
      var _this$props5 = this.props,
        asyncUrl = _this$props5.asyncUrl,
        disabled = _this$props5.disabled,
        onlyCustom = _this$props5.onlyCustom,
        suggestedAnswers = _this$props5.suggestedAnswers,
        optionType = _this$props5.optionType,
        placeholder = _this$props5.placeholder,
        closeOnSelect = _this$props5.closeOnSelect;
      var options = this.props.options;
      var menuIsOpen = this.state.menuIsOpen;
      if (suggestedAnswers && asyncUrl) {
        options = suggestedAnswers.map(function (s) {
          return {
            value: s.id,
            label: s.name
          };
        });
      } else if (suggestedAnswers) {
        var names = suggestedAnswers.map(function (s) {
          return s.name;
        });
        var suggestedOptions = options.filter(function (option) {
          return names.includes(option.label);
        });
        var filteredOptions = options.filter(function (option) {
          return !names.includes(option.label);
        });
        options = [{
          label: 'Suggested for you',
          options: suggestedOptions
        }].concat([{
          label: "All ".concat(optionType),
          options: filteredOptions
        }]);
      }
      if (onlyCustom) {
        return null;
      }
      if (asyncUrl) {
        return /*#__PURE__*/React.createElement(AsyncSelect, {
          components: components,
          styles: _objectSpread({}, dropdownStyleUtils),
          loadOptions: this.getOptions,
          defaultOptions: options,
          value: this.nonCustomValues,
          maxMenuHeight: 500,
          onChange: function onChange(e) {
            _this2.handleNonCustomSelectChange(e);
            _this2.setState({
              menuIsOpen: !closeOnSelect
            });
          },
          isDisabled: disabled,
          closeOnSelect: false,
          closeMenuOnSelect: closeOnSelect,
          onSelectResetsInput: false,
          classNamePrefix: "clora-multiselect",
          placeholder: placeholder,
          isMulti: true,
          menuIsOpen: menuIsOpen,
          cacheOptions: true
        });
      }
      return /*#__PURE__*/React.createElement(Select, {
        components: components,
        styles: _objectSpread({}, dropdownStyleUtils),
        options: options,
        value: this.nonCustomValues,
        maxMenuHeight: 450,
        onChange: function onChange(e) {
          _this2.handleNonCustomSelectChange(e);
          _this2.setState({
            menuIsOpen: closeOnSelect ? false : menuIsOpen
          });
        },
        isDisabled: disabled,
        classNamePrefix: "clora-multiselect",
        placeholder: placeholder,
        isMulti: true,
        menuIsOpen: menuIsOpen,
        onMenuOpen: this.handleToggleMenu,
        onMenuClose: closeOnSelect ? function () {} : this.handleToggleMenu,
        menuShouldScrollIntoView: false
      });
    }
  }, {
    key: "renderCheckboxMultiSelect",
    value: function renderCheckboxMultiSelect() {
      var _this3 = this;
      var _this$props6 = this.props,
        options = _this$props6.options,
        subtext = _this$props6.subtext,
        hasOther = _this$props6.hasOther,
        suggestedAnswers = _this$props6.suggestedAnswers,
        marginTop = _this$props6.marginTop,
        questionKey = _this$props6.questionKey,
        onboardingQuestionnaire = _this$props6.onboardingQuestionnaire;
      var otherSelected = this.state.otherSelected;
      var subtextStyle = onboardingQuestionnaire ? 'subtext' : '';
      var newOptions = questionKey === 'role_level' ? reorderSeniorityOption(options, isMobile()) : options;
      return /*#__PURE__*/React.createElement("div", {
        className: questionKey === 'role_level' ? 'checkbox-multiselect-with-filter' : ''
      }, this.renderLimitWarning(), subtext && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-".concat(marginTop, " ").concat(subtextStyle)
      }, subtext), /*#__PURE__*/React.createElement("div", {
        className: "checkbox-multi-select"
      }, newOptions.map(function (item) {
        return /*#__PURE__*/React.createElement("label", {
          className: "custom-checkbox-container ".concat(suggestedAnswers && suggestedAnswers.includes(item.label) && 'suggested'),
          htmlFor: item.value,
          key: item.label
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: item.value,
          checked: _this3.nonCustomValues.findIndex(function (x) {
            return x.value === item.value;
          }) !== -1,
          onChange: function onChange() {
            return _this3.handleNonCustomSelectChange(item);
          }
        }), /*#__PURE__*/React.createElement("span", {
          className: "checkmark"
        }), /*#__PURE__*/React.createElement("span", {
          className: "label body-text-2"
        }, item.label), suggestedAnswers && suggestedAnswers.includes(item.label) && /*#__PURE__*/React.createElement("span", {
          className: "suggested-text"
        }, "Suggested for you"));
      })), hasOther && /*#__PURE__*/React.createElement("div", {
        className: "align-horizontally-parent"
      }, /*#__PURE__*/React.createElement("div", {
        className: "align-horizontally-child"
      }, /*#__PURE__*/React.createElement("label", {
        className: "custom-checkbox-container body-text-2",
        htmlFor: "other"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "other",
        checked: otherSelected,
        onChange: function onChange() {
          return _this3.toggleOtherSelected({
            label: 'Other'
          });
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, "Other"))), /*#__PURE__*/React.createElement("div", {
        className: "align-horizontally-child ms-3"
      }, /*#__PURE__*/React.createElement(MultiSelectCreatableTextInput, {
        values: this.customValues,
        handleCustomSelectChange: this.handleCustomSelectChange
      }))));
    }
  }, {
    key: "renderSelectedItems",
    value: function renderSelectedItems() {
      var _this4 = this;
      if (this.nonCustomValues.length === 0 && this.customValues.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "tag-selection-set"
      }, /*#__PURE__*/React.createElement("div", {
        className: "non-custom-values"
      }, this.nonCustomValues.map(function (opt, idx) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tag-selection non-custom-values"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "selected-item-".concat(idx)
        }, opt.label), /*#__PURE__*/React.createElement("i", {
          role: "menuitem",
          id: "selected-item-".concat(idx),
          className: "fa fa-times",
          onClick: function onClick() {
            return _this4.handleNonCustomSelectChange(opt);
          },
          tabIndex: "0"
        }));
      })), /*#__PURE__*/React.createElement("div", {
        className: "custom-values"
      }, this.customValues.map(function (opt, idx) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tag-selection"
        }, /*#__PURE__*/React.createElement("label", {
          htmlFor: "selected-custom-item-".concat(idx)
        }, opt.label), /*#__PURE__*/React.createElement("i", {
          role: "menuitem",
          id: "selected-custom-item-".concat(idx),
          className: "fa fa-times",
          onClick: function onClick() {
            return _this4.handleCustomSelectChange(_this4.customValues.filter(function (v) {
              return v.label !== opt.label;
            }), 'remove-value');
          },
          tabIndex: "0"
        }));
      })));
    }
  }, {
    key: "renderCheckboxMultiSelectWithFilter",
    value: function renderCheckboxMultiSelectWithFilter() {
      var _this5 = this;
      var _this$props7 = this.props,
        questionKey = _this$props7.questionKey,
        subtext = _this$props7.subtext,
        hasOther = _this$props7.hasOther,
        suggestedAnswers = _this$props7.suggestedAnswers,
        marginTop = _this$props7.marginTop,
        hasFilter = _this$props7.hasFilter,
        text = _this$props7.text;
      var _this$state = this.state,
        usedOptions = _this$state.usedOptions,
        otherSelected = _this$state.otherSelected,
        showLimitReached = _this$state.showLimitReached;
      var isDisabled = !!this.isLimitReached();
      var options = questionKey === 'role_level' ? reorderSeniorityOption(usedOptions, isMobile()) : usedOptions;
      return /*#__PURE__*/React.createElement("div", {
        className: "checkbox-multiselect-with-filter"
      }, showLimitReached && this.renderLimitWarning(), subtext && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-".concat(marginTop)
      }, ReactHtmlParser(subtext)), this.renderSelectedItems(), hasFilter && /*#__PURE__*/React.createElement("div", {
        className: "filter"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-field"
      }, /*#__PURE__*/React.createElement("input", {
        className: "input-base border-radius-small",
        type: "text",
        name: "role",
        placeholder: "Filter ".concat(text.toLowerCase()),
        onChange: function onChange(e) {
          return _this5.handleFilterChange(e.target.value);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "checkbox-multi-select"
      }, options.map(function (item) {
        var isChecked = _this5.nonCustomValues.findIndex(function (x) {
          return x.value === item.value;
        }) !== -1;
        return /*#__PURE__*/React.createElement("label", {
          className: "\n                  custom-checkbox-container ".concat(suggestedAnswers && suggestedAnswers.includes(item.label) && 'suggested', "\n                  ").concat(isDisabled && !isChecked ? 'disabled' : '', "\n                "),
          htmlFor: "".concat(item.label.replace(/\s+/g, '-').toLowerCase(), "-").concat(item.value),
          key: item.label
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "".concat(item.label.replace(/\s+/g, '-').toLowerCase(), "-").concat(item.value),
          checked: isChecked,
          onChange: function onChange() {
            return _this5.handleNonCustomSelectChange(item);
          }
        }), /*#__PURE__*/React.createElement("span", {
          className: "checkmark"
        }), /*#__PURE__*/React.createElement("span", {
          className: "label body-text-2"
        }, item.label), suggestedAnswers && suggestedAnswers.includes(item.label) && /*#__PURE__*/React.createElement("span", {
          className: "suggested-text"
        }, "Suggested for you"));
      })), hasOther && questionKey === 'skills' && /*#__PURE__*/React.createElement("div", {
        className: "other-wrapper"
      }, /*#__PURE__*/React.createElement("label", {
        className: "\n                custom-checkbox-container body-text-2\n                ".concat(isDisabled && !otherSelected ? 'disabled' : '', "\n              "),
        htmlFor: "other-".concat(questionKey),
        key: "other-".concat(questionKey)
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "other-".concat(questionKey),
        checked: otherSelected,
        onChange: function onChange() {
          return _this5.toggleOtherSelected({
            label: 'Other'
          });
        },
        disabled: isDisabled
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, "Other")), /*#__PURE__*/React.createElement(MultiSelectCreatableTextInput, {
        values: this.customValues,
        handleCustomSelectChange: this.handleCustomSelectChange,
        showDropdownIndicator: false
      })));
    }
  }, {
    key: "renderDropDownMultiSelect",
    value: function renderDropDownMultiSelect() {
      var _this$props8 = this.props,
        subtext = _this$props8.subtext,
        hasOther = _this$props8.hasOther,
        onlyCustom = _this$props8.onlyCustom,
        disabled = _this$props8.disabled,
        marginTop = _this$props8.marginTop,
        questionKey = _this$props8.questionKey;
      return /*#__PURE__*/React.createElement("div", {
        className: "multi-select"
      }, this.renderLimitWarning(), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-".concat(marginTop, " ").concat(disabled ? 'disabled-grey' : '')
      }, ReactHtmlParser(subtext), onlyCustom && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Press Enter after each item.")), hasOther && !onlyCustom && questionKey === 'tools' && /*#__PURE__*/React.createElement("div", {
        className: "mt-5"
      }, /*#__PURE__*/React.createElement("span", {
        className: "medium-weight"
      }, "Don't see your choice? "), "Click\xA0", /*#__PURE__*/React.createElement("span", {
        role: "button",
        className: "highlight-text pointer-underline-text",
        onClick: disabled ? function () {} : this.toggleOtherSelected,
        tabIndex: 0
      }, "here"), "\xA0to add it.")), this.renderCreatableTextInput(), this.renderSelect());
    }
  }, {
    key: "render",
    value: function render() {
      var style = this.props.style;
      if (style === 'multiselect') {
        return this.renderDropDownMultiSelect();
      }
      if (style === 'checkbox_multiselect_filter') {
        return this.renderCheckboxMultiSelectWithFilter();
      }
      return this.renderCheckboxMultiSelect();
    }
  }]);
}(Component);
MultiSelectInput.propTypes = {
  questionKey: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  handleSelectChange: PropTypes.func.isRequired,
  asyncUrl: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hasOther: PropTypes.bool.isRequired,
  hasFilter: PropTypes.bool.isRequired,
  style: PropTypes.string,
  limit: PropTypes.number,
  onlyCustom: PropTypes.bool,
  suggestedAnswers: PropTypes.shape([]),
  optionType: PropTypes.string,
  placeholder: PropTypes.string,
  menuIsOpen: PropTypes.bool,
  marginTop: PropTypes.string,
  userId: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  onboardingQuestionnaire: PropTypes.bool,
  closeOnSelect: PropTypes.bool
};
MultiSelectInput.defaultProps = {
  subtext: '',
  disabled: false,
  options: [],
  asyncUrl: null,
  style: 'multiselect',
  limit: null,
  onlyCustom: false,
  suggestedAnswers: null,
  optionType: '',
  placeholder: 'Select or type...',
  menuIsOpen: true,
  marginTop: '20',
  onboardingQuestionnaire: false,
  closeOnSelect: false
};
export default MultiSelectInput;